module.exports = __webpack_public_path__ + "img/treppenaufgang_2.fae9144a.jpg";